import { Action } from '../actions';
import {
  firstReferenceFromReferenceList,
  mergeEntities,
  transformObjects,
} from '../helpers';
import {
  transformSearchContest,
  transformSearchFreelancers,
  transformSearchHistory,
  transformSearchKeywordProjects,
  transformSearchMyContacts,
  transformSearchMyProjects,
} from './search.transformers';

export function searchContestsReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'searchContests') {
        const { result, refList } = action.payload;
        return mergeEntities<'searchContests'>(
          state,
          transformObjects(result, transformSearchContest),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    default:
      return state;
  }
}

export function searchHistoryReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'searchHistory') {
        const { result, refList } = action.payload;
        return mergeEntities<'searchHistory'>(
          state,
          transformObjects(result, transformSearchHistory),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    default:
      return state;
  }
}

export function searchKeywordProjectsReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'searchKeywordProjects') {
        const { result, refList } = action.payload;
        return mergeEntities<'searchKeywordProjects'>(
          state,
          transformObjects(result, transformSearchKeywordProjects),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    default:
      return state;
  }
}

export function searchMyContactsReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'searchMyContacts') {
        const { result, refList } = action.payload;
        return mergeEntities<'searchMyContacts'>(
          state,
          transformObjects(result, transformSearchMyContacts),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    default:
      return state;
  }
}

export function searchMyProjectsBuyerReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'searchMyProjectsBuyer') {
        const { result, refList } = action.payload;
        return mergeEntities<'searchMyProjectsBuyer'>(
          state,
          transformObjects(result, transformSearchMyProjects),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    default:
      return state;
  }
}

export function searchFreelancersReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'searchFreelancers') {
        const { result, refList } = action.payload;
        return mergeEntities<'searchFreelancers'>(
          state,
          transformObjects(result, transformSearchFreelancers),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/de/webapp/src/app/@shared/datastore/search/search.reducer.ts